import api from "../../../api/clinique/_consultations";

const state = () => ({
    moment_consultations: [],
    typesConsultation: [],
    typeConsSelected: [],
    tarif_consultation: [],
    bonConsultation: [],
    consult_for_patient: [],
    liste_consultations: [],

    allConsultations: [],   // TODO:: REMOVE LATER
    all_factures: [],

    // -------- STATS CONSULTATION  ----------
    consultationsEnAttente: null,
    todayConsultationsCount: null,
    currentMonthConsultationsCount: null,
    count_consultation_attente: 0,
    // ---------------------------------------

    liste_filiation: [],

    consultation_est_actif: [],

    prescriptions_pharmacie: [],

    duree_validite: 0,
    ref_bon_consultation: '',

    bon_consommables: [],

    patient_has_ongoing_type_consultation: 0,
    can_add_differential_computing: '',
    is_vente_from_caisse: 0,
    selected_bon_consommables: [],
    is_pre_saved_bon: false,
    selected_bon_id: null
});

// getters
const getters = {
    moment_consultations: (state) => {
        return state.moment_consultations;
    },

    typesConsultations: (state) => {
        return state.typesConsultation;
    },

    typeConsSelected: (state) => {
        return state.typeConsSelected;
    },

    tarif_consultation: (state) => {
        return state.tarif_consultation;
    },

    bonConsultationStored: (state) => {
        return state.bonConsultation;
    },

    consult_for_patient: (state) => {
        return state.consult_for_patient;
    },

    // TODO: To remove later
    allConsultations: (state) => {
        return state.allConsultations;
    },

    all_factures: (state) => {
        return state.all_factures;
    },

    // -------- STATS CONSULTATION  ----------  
    consultationsEnAttente: (state) => {
        return state.consultationsEnAttente
    },

    todayConsultationsCount: (state) => {
        return state.todayConsultationsCount
    },

    currentMonthConsultationsCount: (state) => {
        return state.currentMonthConsultationsCount
    },

    /**
     * Détermine si un patient est en suite de soin
     * @param {*} state 
     * @returns 
     */
    consultation_est_actif: (state) => {
        return state.consultation_est_actif
    },
    // ----------------------------------------
    prescriptions_pharmacie: (state) => {
        return state.prescriptions_pharmacie
    },

    duree_validite: (state) => {
        return state.duree_validite;
    },

    count_consultation_attente: (state) => {
        return state.count_consultation_attente;
    },

    liste_filiation: (state) => {
        return state.liste_filiation;
    },

    ref_bon_consultation: (state) => {
        return state.ref_bon_consultation;
    },

    bon_consommables: (state) => {
        return state.bon_consommables;
    },

    patient_has_ongoing_type_consultation: (state) => {
        return state.patient_has_ongoing_type_consultation;
    },

    can_add_differential_computing: (state) => {
        return state.can_add_differential_computing;
    },

    liste_consultations: (state) => {
        return state.liste_consultations;
    },

    is_vente_from_caisse: (state) => {
        return state.is_vente_from_caisse;
    },

    selected_bon_consommables: (state) => {
        return state.selected_bon_consommables;
    },

    is_pre_saved_bon: (state) => {
        return state.is_pre_saved_bon;
    },

    selected_bon_id: (state) => {
        return state.selected_bon_id;
    },
};
// mutations
const mutations = {
    SET_MOMENT_CONSULTATIONS(state, moments) {
        state.moment_consultations = moments;
    },

    SET_TYPES(state, types) {
        state.typesConsultation = types;
    },

    SET_TYPE_CONS_SELECTED(state, type) {
        state.typeConsSelected = type;
    },

    SET_TARIF(state, tarif) {
        state.tarif_consultation = tarif;
    },

    SET_BON_CONSULTATION(state, bon) {
        state.bonConsultation = bon;
    },

    SET_PATIENT_CONSULT_SELECTED(state, p) {
        state.consult_for_patient = p
    },

    SET_ALL_CONSULTATIONS(state, cons) {
        state.allConsultations = cons
    },

    SET_ALL_FACTURES(state, facture) {
        state.all_factures = facture
    },

    // -------- STATS CONSULTATION  ----------  
    SET_CONSULTATIONS_EN_ATTENTE(state, consultationsEnAttente) {
        state.consultationsEnAttente = consultationsEnAttente
    },

    SET_COUNT_CONSULTATIONS_EN_ATTENTE(state, count_consultation_attente) {
        state.count_consultation_attente = count_consultation_attente
    },

    SET_COUNT_TODAY_CONSULTATIONS(state, todayConsultationsCount) {
        state.todayConsultationsCount = todayConsultationsCount
    },

    SET_COUNT_MONTH_CONSULTATIONS(state, currentMonthConsultationsCount) {
        state.currentMonthConsultationsCount = currentMonthConsultationsCount
    },
    // ----------------------------------------

    SET_PRESCRIPTIONS_PHARMACIE(state, prescription) {
        state.prescriptions_pharmacie = prescription
    },

    SET_DUREE_VALIDITE(state, duree) {
        state.duree_validite = duree;
    },

    SET_ETAT_EN_CONSULTATION(state, etat) {
        state.consultation_est_actif = etat;
    },

    SET_LISTE_FILIATION(state, filiations) {
        state.liste_filiation = filiations;
    },

    SET_REF_BON_CONSULTATION(state, ref) {
        state.ref_bon_consultation = ref;
    },

    SET_CONSOMMABLE_BON(state, consommable) {
        state.bon_consommables = consommable;
    },

    SET_PATIENT_HAS_ONGOING_TYPE_CONSULTATION(state, check_status) {
        state.patient_has_ongoing_type_consultation = check_status;
    },

    SET_CAN_ADD_DIFFERENTIAL_COMPUTING(state, check_status) {
        state.can_add_differential_computing = check_status;
    },

    SET_LISTE_CONSULTATIONS(state, check_status) {
        state.liste_consultations = check_status;
    },

    SET_IS_VENTE_FROM_CAISSE(state, is_vente_caisse) {
        state.is_vente_from_caisse = is_vente_caisse;
    },

    SET_SELECTED_BON_CONSOMMABLES(state, consommables) {
        state.selected_bon_consommables = consommables;
    },

    SET_IS_PRE_SAVED_BON(state, is_pre_saved) {
        state.is_pre_saved_bon = is_pre_saved;
    },

    SET_SELECTED_BON_ID(state, bon_id) {
        state.selected_bon_id = bon_id;
    }
};

// actions
const actions = {
    getMomentsConsultations({ commit }) {
        return new Promise((resolve, reject) => {
            api.getMomentsConsultations().then(
                (response) => {
                    commit("SET_MOMENT_CONSULTATIONS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getTypesConsultations({ commit }) {
        api.getTypesConsultations().then((response) => {
            commit("SET_TYPES", response);
        });
    },


    getTarifConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getTarifConsultation(data).then(
                (response) => {
                    commit("SET_TARIF", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getTypesForConsultation({ commit }, idConsult) {
        return new Promise((resolve, reject) => {
            api.getTypesForConsultation(idConsult).then(
                (response) => {
                    commit("SET_PATIENT_CONSULT_SELECTED", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAllConsultations({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAllConsultation().then(
                (response) => {
                    commit("SET_ALL_CONSULTATIONS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAllFactures({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAllFactures().then(
                (response) => {
                    commit("SET_ALL_FACTURES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getPrixCarnet({ commit }) {
        return new Promise((resolve, reject) => {
            api.getPrixCarnet().then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    geDureeBonConsultation({ commit }) {
        return new Promise((resolve, reject) => {
            api.geDureeBonConsultation().then(
                (response) => {
                    commit;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getLastConsultationByPatientEtType({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getLastConsultationByPatientEtType(data.idPatient, data.idTypeConsultation).then(response => {
                resolve(response)
                commit('SET_ETAT_EN_CONSULTATION', response)
            }, error => {
                reject(error)
            })
        })
    },

    getLastConsultationCpnByPatient({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getLastConsultationCpnByPatient(data.idPatient, data.idTypeConsultation).then(response => {
                resolve(response)
                commit('SET_ETAT_EN_CONSULTATION', response)
            }, error => {
                reject(error)
            })
        })
    },
    /**
     * ---------------------------------------------------------
     *                  STATS CONSULTATION
     */
    getConsultationsEnAttente({ commit }) {
        return new Promise((resolve, reject) => {
            api.getConsultationAttente().then(response => {
                resolve(response)
                commit('SET_COUNT_CONSULTATIONS_EN_ATTENTE', response)
            }, error => {
                reject(error)
            })
        })
    },

    getCountTodayConsultations({ commit }) {
        return new Promise((resolve, reject) => {
            api.getCountTodayConsultations().then(response => {
                resolve(response)
                commit('SET_COUNT_TODAY_CONSULTATIONS', response)
            }, error => {
                reject(error)
            })
        })

    },

    getCountMonthConsultations({ commit }, month) {
        return new Promise((resolve, reject) => {
            api.getCountMonthConsultations(month).then(response => {
                resolve(response)
                commit('SET_COUNT_MONTH_CONSULTATIONS', response)
            }, error => {
                reject(error)
            })
        })

    },
    // ----------   FIN STATS CONSULTATTION     --------------------

    // PRESCRIPTIONS PHARMACIE
    getPrescriptionsPharmacie({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getPrescriptionsPharmacie(data.consultation_id, data.bought).then(response => {
                resolve(response)
                commit('SET_PRESCRIPTIONS_PHARMACIE', response)
            }, error => {
                reject(error)
            })
        })
    },

    sendPrescriptionsAfterVente({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.sendPrescriptionsAfterVente(data).then(
                response => {
                    resolve(response)
                    if (response[0].ordonnances.length > 0)
                        commit('SET_PRESCRIPTIONS_PHARMACIE', response[0].ordonnances[0].prescriptions)
                    else
                        commit('SET_PRESCRIPTIONS_PHARMACIE', [])
                }, error => {
                    reject(error)
                }
            )
        })
    },
   
    getDureeValiditeConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getDureeValiditeConsultation(data).then(
                (response) => {
                    commit("SET_DUREE_VALIDITE", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeFiliation({ commit }, data ) {
        return new Promise((resolve, reject) => {
            api.getListeFiliation(data).then(
                response => {
                    commit('SET_LISTE_FILIATION', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsommableBonForTypeConsultation({ commit }, {type_consultation_id}) {
        return new Promise((resolve, reject) => {
            api.getConsommableBonForTypeConsultation(type_consultation_id).then(
                response => {
                    commit('SET_CONSOMMABLE_BON', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    validatePendingConsultation({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.validatePendingConsultation(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    checkIfPatientHasOnGoingTypeConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.checkIfPatientHasOnGoingTypeConsultation(data).then(
                response => {
                    commit('SET_PATIENT_HAS_ONGOING_TYPE_CONSULTATION', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getDifferentialComputing({ commit }) {
        return new Promise((resolve, reject) => {
            api.getDifferentialComputing().then(
                response => {
                    commit('SET_CAN_ADD_DIFFERENTIAL_COMPUTING', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    storeBonConsultation({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.storeBonConsultation(data).then(
                (response) => {
                    commit("SET_BON_CONSULTATION", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeConsultations({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeConsultations(data).then(
                (response) => {
                    commit("SET_LISTE_CONSULTATIONS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};